import {
  SyncCommitComponentQueryState,
  SyncCommitComponentResponse,
} from "./sync-commit-component.type"
import Axios, { AxiosResponse } from "axios"

export const getSyncCommitComponentListMiddleware = async (
  params?: SyncCommitComponentQueryState
) => {
  try {
    const response: AxiosResponse<{
      data: SyncCommitComponentResponse[]
      total: number
    }> = await Axios.get(`/api/sync-commit-component/get-list`, {
      params,
    })
    return {
      data: response.data.data,
      total: response.data.total,
    }
  } catch (error) {
    return {
      data: [],
      total: 0,
    }
  }
}
